(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('eventsLast', EventsLast)

    /** @ngInject */
    function EventsLast($rootScope, HelperService, AuthenticationService, EventService, PATHS, DATA_EVENTS) {
        function EventsLastController($scope) {
            const vm = this;

            vm.getEventImage = event => {
                return HelperService.imageHandlerPath('event', event.Id, event.Image);
            }

            vm.init = () => {
                vm.events = [];
                vm.isLoading = true;

                getEvents();
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                vm.init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            function getEvents() {
                HelperService.startLoading('.last-elements.events');

                let isMobile = $rootScope.isMobile;

                vm.isLoading = true;
                let userData = AuthenticationService.getUserData();
                let parameters = {
                    ResponsibilityId: userData.Responsibility.Id,
                    Active: true,
                    Highlight: true,
                    OrderBy: 'StartDate',
                    OrderDescending: false,
                    PerPage: isMobile ? 11 : 3,
                    Skip: 0,
                    StartDate: moment().format()
                };

                if (vm.excludeEventId)
                    parameters.ExcludeEventId = vm.excludeEventId;

                EventService
                    .getAllByParameters(parameters, userData.Id)
                    .then(success => {
                        vm.isLoading = false;
                        vm.events = success.Events;
                        HelperService.stopLoading('.last-elements.events');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.last-elements.events');
                    })
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            controller: EventsLastController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/events-last/events-last.html`,
            scope: {
                excludeEventId: '='
            }
        }
    }
}());